<template>
  <upload
    :accept="accept"
    :format="format"
    action="/"
    :multiple="true"
    :show-upload-list="false"
    v-bind="$listeners"
    :before-upload="before_upload"
  >
    <i-button icon="ios-cloud-upload-outline" size="large" type="primary" :loading="is_loading">
      {{ $t('core.document.form.selected_file_btn') }}
    </i-button>
  </upload>
</template>

<script>
  const formats = ['png', 'jpg', 'jpeg', 'pdf'];

  export default {
    props: {
      is_loading: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      accept: formats.map((i) => `.${i}`).join(','),
      format: formats
    }),
    methods: {
      before_upload(file) {
        const max_file_size = 11 * 1000 * 1000;
        if (file.size < max_file_size) {
          this.$emit('before_upload', file);
        } else {
          const warning_msg = this.$t('core.document.error.max_size', { filename: file.name });
          this.$noty.warning(warning_msg);
        }
        return false;
      }
    }
  };
</script>
